export function getConnectedPlatforms(tokens) {
    return tokens ? tokens.map(token => token.platform) : [];
}
